'use client'
import { useState, useRef } from 'react'

/**
 * Tooltip component using Tailwind CSS and minimal JS.
 * @param {object} props
 * @param {React.ReactNode} props.title - Tooltip content
 * @param {React.ReactNode} props.children - Trigger element
 * @param {number} [props.width=300] - Tooltip width in px
 */
export function Tooltip({ title, children, width = 300 }) {
  const [open, setOpen] = useState(false)
  const ref = useRef(null)
  return (
    <span className="relative" ref={ref}>
      <span
        onClick={() => setOpen((v) => !v)}
        className="cursor-pointer underline text-xs text-gray-500"
      >
        {children}
      </span>
      {open && (
        <div
          className="absolute z-50 left-1/2 -translate-x-1/2 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg p-4 text-gray-900"
          style={{ minWidth: width, maxWidth: width }}
        >
          <button
            className="absolute top-2 right-2 text-gray-400 hover:text-gray-300"
            onClick={() => setOpen(false)}
            aria-label="Close"
          >
            ×
          </button>
          {title}
        </div>
      )}
    </span>
  )
}
